<ng-container *ngFor="let cc of iconList">
  <biosimulations-fa-icon [icon]="$any(['fab', cc])"></biosimulations-fa-icon>
</ng-container>
